import React from 'react'
import Help from '@/components/Icon/Help'
import { useSelector } from '@/store'
import { LINK_LANG } from '@/constants/language'
const HelpCenter = () => {
  const lang = useSelector((state) => state.language?.lang)
  const toHelp = () => {
    window.open(LINK_LANG[lang])
  }

  return (
    <div style={{ display: 'flex', color: '#001529', cursor: 'pointer' }} onClick={toHelp}>
      <Help></Help>
    </div>
  )
}

export default HelpCenter
